import React, { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { useStaticQuery, graphql } from 'gatsby';
import { isBrowser } from '../utils/is-browser';
import Survey from '../components/survey';

export const SURVEY_USER_ID_COOKIE_NAME = 'survey_user_id';

export const generateSurveyId = () => {
  const randomUserId = uuid().replace(/-/g, '');

  if (isBrowser) {
    window.CookieControl.saveCookie(
      SURVEY_USER_ID_COOKIE_NAME,
      randomUserId,
      30
    );
  }
};

if (isBrowser && !window.generateSurveyId) {
  window.generateSurveyId = generateSurveyId;
}

export const useSurvey = (currentPath) => {
  useEffect(() => {
    if (isBrowser) {
      const currentSurveyUserId = window.CookieControl?.getCookie(
        SURVEY_USER_ID_COOKIE_NAME
      );
      const isAnalyticsAccepted = window.CookieControl?.getCategoryConsent(1); // Functional = 0, Analytics = 1, Marketing = 2. For details: https://www.civicuk.com/cookie-control/documentation/available-options?searchTerm=getcategoryconsent

      // Check if survey_user_id already exists in cookies
      if (!currentSurveyUserId && isAnalyticsAccepted) {
        // Generate a random user ID
        generateSurveyId();
      }
    }
  }, []);

  const data = useStaticQuery(graphql`
    query surveys {
      allContentfulSurvey {
        nodes {
          ...SurveyFragment
        }
      }
    }
  `);

  const surveys = data?.allContentfulSurvey?.nodes;

  const firstMatchedSurvey = surveys?.find(
    (survey) =>
      // check if isExcluded
      !survey.excludeSurveyPath?.some((path) => currentPath?.includes(path)) &&
      // check if isIncluded
      survey.showSurveyPath.some((path) => currentPath?.includes(path))
  )?.surveyForm;

  if (!surveys || surveys.length === 0 || !firstMatchedSurvey) return null;

  return <Survey contentfulData={firstMatchedSurvey} />;
};
